import React, { useEffect } from 'react';
import { useAuth } from '@shared/providers/AuthContext';
import { useTheme, type ClinicServiceType } from '@shared/providers/theme/ThemeContext';

/**
 * Theme Wrapper - Bridges AuthContext with ThemeContext
 * Passes clinic.service_type to ThemeProvider for service type restriction
 */
export const ThemeWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { clinic } = useAuth();
  const { setClinicServiceType } = useTheme();

  const normalizeClinicServiceType = (value?: string | null): ClinicServiceType => {
    if (!value) return null;
    const normalized = value.toLowerCase();

    if (normalized === 'a2' || normalized === 'r2' || normalized === 'both') {
      return normalized as ClinicServiceType;
    }

    // Unknown value -> treat as "both" (no restriction)
    return null;
  };

  // Update theme context when clinic service_type changes
  useEffect(() => {
    setClinicServiceType(normalizeClinicServiceType(clinic?.service_type ?? null));
  }, [clinic?.service_type, setClinicServiceType]);

  return <>{children}</>;
};
